// extracted by mini-css-extract-plugin
module.exports =  {"content":"ProjectFailureRateInsights-module_content__lRGTqdWS7Pc7juXuHNvv","csvDownloadWrap":"ProjectFailureRateInsights-module_csvDownloadWrap__luORpaIN3V7SWk9EYbfp"};